export const dev = (api_host) => ({
    admin_url: `https://admin.${api_host}.org/admin`,
    api_v2_url: `https://api.${api_host}.org/v2`,
    console_api_url: `https://console-api.${api_host}.org/v4/console`,
    blog_api_url: `https://usercontent.${api_host}.org/v4/liveblog`,
    comments_api_url: `https://livecomments.${api_host}.org/v4/livecomments`,
    console_url: `https://console.${api_host}.org`,
    auth_url: `https://auth.${api_host}.org`,
    iam_url: `https://iam.${api_host}.org`,
    portal_url: `https://portal.${api_host}.org`,
    isProduction: false,
    environment: api_host,
    version_poll_interval: 60 * 1000,
    usernotification_api_url: `https://notifications.${api_host}.org/v5`,
});
